export function dashboardSubmittedPayrollsItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-item-template-submitted-payrolls.html";
    const html = /*html*/`<apex-dashboard-submitted-payrolls-container></apex-dashboard-submitted-payrolls-container>`;
    $templateCache.put(path, html);
}

export function dashboardSubmittedPayrollsListItemTemplate($templateCache) {
    'ngInject';
    const path = "/Scripts/Page/Home/apex-dashboard-list-item-template-submitted-payrolls.html";
    const html = /*html*/`
        <p ng-if="dashboard.count === 0">No payrolls have been submitted at this time.</p>
        <p ng-if="dashboard.count > 0">Payrolls have been submitted that you are authorized to review at this time.</p>
    `;
    $templateCache.put(path, html);
}
